import React from 'react';
import { Typography, Card, Row, Col, Statistic, Divider } from 'antd';
import { RefLanguage } from '../hooks/LanguageHooks';

const { Title, Paragraph, Text } = Typography;

function DocsResourcesPage() {
    const i18n = RefLanguage();

    return (
        <div style={{ maxWidth: 1200, margin: '0 auto', padding: '24px' }}>
            <Typography>
                <Title level={2}>{i18n.t("docsResourcesTitle")}</Title>
                
                <Paragraph style={{ fontSize: '16px', marginBottom: '32px' }}>
                    {i18n.t("docsResourcesIntro")}
                </Paragraph>

                <Title level={3}>{i18n.t("docsResourcesMarkersTitle")}</Title>
                
                <Row gutter={[24, 24]} style={{ marginBottom: '32px' }}>

                    <Col xs={24} sm={12} lg={6}>
                        <Card size="small">
                            <Statistic
                                title="ITS (internal transcribed spacer)"
                                value={1570910}
                                precision={0}
                                suffix={i18n.t("docsResourcesReads")}
                            />
                            <Paragraph style={{ fontSize: '12px', marginTop: '8px' }}>
                                {i18n.t("docsResourcesITSDesc")}
                            </Paragraph>
                        </Card>
                    </Col>

                    <Col xs={24} sm={12} lg={6}>
                        <Card size="small">
                            <Statistic
                                title="SSU (18S rRNA)"
                                value={281307}
                                precision={0}
                                suffix={i18n.t("docsResourcesReads")}
                            />
                            <Paragraph style={{ fontSize: '12px', marginTop: '8px' }}>
                                {i18n.t("docsResourcesSSUDesc")}
                            </Paragraph>
                        </Card>
                    </Col>

                    <Col xs={24} sm={12} lg={6}>
                        <Card size="small">
                            <Statistic
                                title="LSU (28S rRNA)"
                                value={309954}
                                precision={0}
                                suffix={i18n.t("docsResourcesReads")}
                            />
                            <Paragraph style={{ fontSize: '12px', marginTop: '8px' }}>
                                {i18n.t("docsResourcesLSUDesc")}
                            </Paragraph>
                        </Card>
                    </Col>
                    
                    <Col xs={24} sm={12} lg={6}>
                        <Card size="small">
                            <Statistic
                                title="Long rRNA"
                                value={126069}
                                precision={0}
                                suffix={i18n.t("docsResourcesReads")}
                            />
                            <Paragraph style={{ fontSize: '12px', marginTop: '8px' }}>
                                {i18n.t("docsResourcesLongDesc")}
                            </Paragraph>
                        </Card>
                    </Col>
                </Row>

                <Title level={3}>{i18n.t("docsResourcesFeaturesTitle")}</Title>
                
                <Row gutter={[24, 24]}>
                    <Col xs={24} lg={12}>
                        <Card 
                            title={i18n.t("docsResourcesQualityTitle")}
                            size="small"
                        >
                            <Paragraph>
                                {i18n.t("docsResourcesQualityText")}
                            </Paragraph>
                        </Card>
                    </Col>
                    
                    <Col xs={24} lg={12}>
                        <Card 
                            title={i18n.t("docsResourcesTaxonomyTitle")}
                            size="small"
                        >
                            <Paragraph>
                                {i18n.t("docsResourcesTaxonomyText")}
                            </Paragraph>
                        </Card>
                    </Col>
                    
                    <Col xs={24} lg={12}>
                        <Card 
                            title={i18n.t("docsResourcesOffTargetTitle")}
                            size="small"
                        >
                            <Paragraph>
                                {i18n.t("docsResourcesOffTargetText")}
                            </Paragraph>
                        </Card>
                    </Col>
                    
                    <Col xs={24} lg={12}>
                        <Card 
                            title={i18n.t("docsResourcesCoverageTitle")}
                            size="small"
                        >
                            <Paragraph>
                                {i18n.t("docsResourcesCoverageText")}
                            </Paragraph>
                        </Card>
                    </Col>
                </Row>

                <Divider />
                
                <Title level={4}>{i18n.t("docsResourcesCitationTitle")}</Title>
                <Card size="small" style={{ backgroundColor: '#f9f9f9' }}>
                    <Text type="secondary" style={{ fontSize: '12px' }}>
                        {i18n.t("docsResourcesCitationText")}
                    </Text>
                </Card>
            </Typography>
        </div>
    );
}

export default DocsResourcesPage;
